import { render, staticRenderFns } from "./PagesCrud.vue?vue&type=template&id=77cb56c8&scoped=true&"
import script from "./PagesCrud.vue?vue&type=script&lang=js&"
export * from "./PagesCrud.vue?vue&type=script&lang=js&"
import style0 from "./PagesCrud.vue?vue&type=style&index=0&id=77cb56c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cb56c8",
  null
  
)

export default component.exports